import { Button } from "@kopi/ui/components/button";
import { useI18n } from "@/i18n/provider";

/** No native diagnostics or paths are exposed to the cashier. Retrying never clears saved data. */
export function StartupError({ onRetry }: { onRetry: () => void }) {
  const { t } = useI18n();
  return (
    <main id="main" className="flex min-h-dvh items-center justify-center px-6 py-16">
      <section role="alert" aria-labelledby="startup-title" className="w-full max-w-md space-y-4">
        <h1 id="startup-title" className="font-semibold text-2xl tracking-tight">
          {t("startup.failed")}
        </h1>
        <p className="text-muted-foreground">{t("startup.failedHint")}</p>
        <Button type="button" onClick={onRetry}>
          {t("common.retry")}
        </Button>
      </section>
    </main>
  );
}
